import { createSlice } from "@reduxjs/toolkit";
type closeoutRadioProps = {
  isLoading: boolean;
  isfileUpload: boolean;
  snackbarItems: snackBarItems;
  isRequestForm: boolean;
  isRITMRequest: boolean;
};
type snackBarItems = {
  severity: string;
  message: string;
};
const initialState: closeoutRadioProps = {
  isLoading: false,
  isfileUpload: false,
  snackbarItems: {severity: "", message: "" },
  isRequestForm: false,
  isRITMRequest: false,
};
const closeOutRadioSlice = createSlice({
  name: "closeOutRadioSlice",
  initialState,
  reducers: {
    setisfilUpload(state, action) {
      state.isfileUpload = action.payload;
    },
    setSnackBarMessage(state, action) {
      state.snackbarItems = action.payload;
    },
    setRequestForm(state, action) {
      state.isRequestForm = action.payload;
    },
    setRITMRequest(state, action) {
      state.isRITMRequest = action.payload;
    },
    resetSnackBar(state){
      state.snackbarItems = { severity: "", message: "" };
    }
  },
});
export const CloseOutRadioActions = closeOutRadioSlice.actions;
export default closeOutRadioSlice.reducer;
